<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 102 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M102 75.0819C102 73.9564 100.241 73.6182 99.754 74.6327C94.4885 85.5965 85.5965 94.4885 74.6327 99.754C73.6182 100.241 73.9564 102 75.0819 102H101C101.552 102 102 101.552 102 101V75.0819ZM27.9181 102C29.0436 102 29.3816 100.241 28.367 99.7539C16.8156 94.2061 7.56395 84.6325 2.43059 72.8517C1.96652 71.7867 0 72.1155 0 73.2773V101C0 101.552 0.447716 102 1 102H27.9181ZM99.7539 28.367C100.241 29.3816 102 29.0436 102 27.9181V1C102 0.447715 101.552 0 101 0H73.2773C72.1156 0 71.7867 1.96652 72.8517 2.43059C84.6325 7.56395 94.2061 16.8156 99.7539 28.367ZM30.1484 2.43054C31.2134 1.96648 30.8845 0 29.7227 0L1 0C0.447715 0 0 0.447713 0 0.999997V29.7227C0 30.8844 1.96648 31.2134 2.43055 30.1484C7.82516 17.768 17.768 7.82516 30.1484 2.43054ZM51 13C48.7909 13 47 14.7909 47 17V61C47 63.2091 48.7909 65 51 65H52C54.2091 65 56 63.2091 56 61V17C56 14.7909 54.2091 13 52 13H51ZM47 85C47 82.7909 48.7909 81 51 81H52C54.2091 81 56 82.7909 56 85V86C56 88.2091 54.2091 90 52 90H51C48.7909 90 47 88.2091 47 86V85Z"
      fill="currentColor"
    />
  </svg>
</template>
